define([
    './EmailInputDecorator'
], (EmailInputDecorator)=> {
    angular.module('edge.platform.decorator', [])
        .config(['$provide', EmailInputDecorator]);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/decorator/module.js